import { request, type RequestOptions } from '@/utils/request'

// 用于判断 用户属于的前台 Storefront Access 是否有效
export const getStorefrontAuth = (params: any, options: RequestOptions = {}) => {
  console.log('params=====>', params)
  return request('/api/shopify/auth/storefront-auth/validate', {
    method: 'GET',
    params: { ...params },
    ...options,
  })
}
